import React, { useContext, useEffect } from 'react'
import {
  Navigate,
  Outlet,
  useSearchParams,
  useLocation
} from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import Backdrop from '../../components/UI/Backdrop/Backdrop'
import Spinner from '../../components/UI/Spinner/SpinnerPlenna'
import LocationContext from '../../context/LocationContext'
import HeaderContext from '../../context/HeaderContext'
import PrivacyModalContext from '../../context/PrivacyModalContext'
import { isScheduleGuestPublicPath } from '../../utils/scheduleGuestFlow'
import persistMarketingQueryParams from '../../utils/persistMarketingQueryParams'

const ALLOWED_WITHOUT_PRIVACY = [
  '/testAnticonceptivos',
  '/errorRecord',
  '/login',
  '/detalle-servicio',
  '/calendario',
  '/calendario/conflicto-equipo-salud',
  '/calendario/error-continuacion',
  '/calendario/clinicas',
  '/calendario/resumen'
]
const PrivateRoute = (props) => {
  const { currentLocation } = useContext(LocationContext)
  const { userInfo } = useContext(HeaderContext)
  const { setOpenModal } = useContext(PrivacyModalContext)
  const [searchParams] = useSearchParams()
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()
  const routerLocation = useLocation()

  const pregnancy = searchParams.get('pregnancy')
  const allQueryParams = currentLocation?.search || routerLocation.search || ''
  const pathname = routerLocation.pathname || currentLocation?.pathname || ''
  const isGuestSchedulePath = isScheduleGuestPublicPath(pathname)

  // Save utm and webflow params (detalle-servicio and other private schedule entries)
  useEffect(() => {
    persistMarketingQueryParams(allQueryParams)
  }, [allQueryParams])

  // Handles route to redirect
  useEffect(() => {
    if (
      !isAuthenticated &&
      !isLoading &&
      !isScheduleGuestPublicPath(pathname)
    ) {
      const routeToRedirect = currentLocation
      if (routeToRedirect?.pathname) {
        localStorage.setItem(
          'routeToRedirect',
          JSON.stringify(routeToRedirect)
        )
      }
    }
  }, [isAuthenticated, isLoading, currentLocation, pathname])

  // Handles Pregnancy flowExeption
  useEffect(() => {
    if (pregnancy) {
      localStorage.setItem('pregnancy', JSON.stringify(pregnancy))
    }
  }, [pregnancy, isAuthenticated])

  // Handler OpenPrivacyModal
  useEffect(() => {
    const showPrivacyModal = userInfo?.show_privacy
    const isAllowedRoute = ALLOWED_WITHOUT_PRIVACY.includes(pathname)

    if (showPrivacyModal && !isAllowedRoute) {
      setOpenModal(true)
      return
    }

    if (!showPrivacyModal) {
      setOpenModal(false)
    }
  }, [userInfo?.show_privacy, pathname, setOpenModal])

  if (isLoading) {
    return (
      <Backdrop show={true}>
        <Spinner detailSpinner={false} />
      </Backdrop>
    )
  }

  if (!isAuthenticated && pregnancy) {
    const routeToRedirect = currentLocation
    if (routeToRedirect) {
      localStorage.setItem('routeToRedirect', JSON.stringify(routeToRedirect))
    }

    loginWithRedirect({
      screen_hint: 'signup',
      appState: {
        returnTo: '/auth'
      }
    })
    return null
  }

  if (!isAuthenticated && isGuestSchedulePath) {
    return props.children ? props.children : <Outlet />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  if (!userInfo) {
    return (
      <Backdrop show={true}>
        <Spinner detailSpinner={false} />
      </Backdrop>
    )
  }

  if (isAuthenticated) {
    return props.children ? props.children : <Outlet />
  }
}

export default PrivateRoute
